<div class="host-one-month-calendar">
  <host-calendar
    [showYear]="currentYear"
    [showMonth]="currentMonth"
    [from]="'date'"
    [weekLines]="6"
    (showYearChange)="yearChange($event)"
    (showMonthChange)="monthChange($event)"
    (subRightMonth)="subMonth($event)"
    (addLeftMonth)="addMonth($event)"
  >
    <ng-template #header let-listOfWeekName>
      <div
        class="column-header"
        [class.weekend]="i === 5 || i === 6"
        *ngFor="let day of listOfWeekName; let i = index"
      >
        {{ day }}
      </div>
    </ng-template>
    <ng-template #cell let-day>
      <div
        class="cell-body"
        [class.selected]="isSelected(day) && !isAnotherMonth(day)"
        [class.disabled]="isDisableDate(day)"
        [class.range]="
          dateType === 'range' && isInrange(day) && !isAnotherMonth(day)
        "
        [style.width]="cellWidth"
        [style.height]="cellHeight"
        (click)="check(day, $event)"
      >
        <span
          class="date"
          [class.another-month]="isAnotherMonth(day)"
          [class.today]="day.isCurrentDay && !day.isSelectedDay"
        >
          {{ day.number }}
        </span>
      </div>
    </ng-template>
  </host-calendar>
</div>
